import { styled } from 'baseui'

export const CounterBox = styled('fieldset', ({ $theme }) => ({
  maxWidth: '26rem',
  marginTop: '1.5rem',
  marginLeft: 0,
  marginRight: 0,
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: $theme.colors.primary,
  textAlign: 'center',
}))

export const CounterLegend = styled('legend', ({ $theme }) => ({
  paddingLeft: '0.75rem',
  paddingRight: '0.75rem',
  fontWeight: 700,
  color: $theme.colors.primary,
}))

export const CounterValue = styled('span', ({ $theme }) => ({
  fontSize: '1.125rem',
  color: $theme.colors.primary,
}))
